import {fetch} from '../api'


export function testApi() {
	return (dispatch) => fetch(``)
		.then((response) => {
			return response
		})
}
